// services
import { AxiosInstance } from 'axios';
import AxiosInstanceCreator from '../../../services/api';

// models
import type { ChardDashboardOverview, ResProjectChartDashboard } from '../models';
import { BaseApiResponse } from 'modules';

const chartDashboardInstance = new AxiosInstanceCreator({
  baseURL: '/v1/api/chart-dashboard'
}).create();

export const chartDashboardApi = {
  /**
   * 현장 차트 대시보드 데이터 조회 API
   *
   * @param {string} projectId
   */
  async getChartDashboardData(projectId: string): Promise<ResProjectChartDashboard> {
    return await chartDashboardInstance
      .get<ResProjectChartDashboard>(`/project/${projectId}`)
      .then((res) => res.data);
  }
};

export class DashboardAPI {
  Axios: AxiosInstance;
  AxiosV2: AxiosInstance;

  constructor() {
    this.Axios = new AxiosInstanceCreator().create();

    this.AxiosV2 = new AxiosInstanceCreator({
      baseURL: import.meta.env.DEV
        ? '/v2/api/dashboard'
        : `${import.meta.env.VITE_API_URL}/v2/api/dashboard`
    }).create();
  }

  /** Chart Dashboard 데이터 조회 API */
  async getChartDashboardData(): Promise<BaseApiResponse<ChardDashboardOverview>> {
    return await this.AxiosV2.get<BaseApiResponse<ChardDashboardOverview>>(`/chart`).then(
      (res) => res.data
    );
  }
}
